import React from "react";
import { Row } from "react-bootstrap";
import backArrow from "../../assets/icons/back-arrow.svg";
import { Props } from "./interfaces";
import { TitleForm } from "./styles";

const SideForm = ({
  children,
  icon,
  title,
  visible,
  sizeIcon
}: Props
): React.ReactElement => {
  return (
    <div className="sideFormSmall" style={{ paddingRight: 30, paddingLeft: 30 }}>
      <Row style={{ marginTop: 57, marginBottom: 38 }}>
        <img src={backArrow} alt="voltar" onClick={() => visible(false)} />
      </Row>
      <Row className="align-items-center">
        <img src={icon.toString()} alt="icone-pessoa" style={{ marginRight: 23, height:sizeIcon }} />
        <TitleForm>{title}</TitleForm>
      </Row>

      <Row>{children}</Row>
    </div>
  );
};

export default SideForm;
